import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { IconButton, OutlinedInput } from '@mui/material';
import AccurityIcon from '../../icon/components/AccurityIcon';
import { useOnEnterHandler } from '../hooks/onEnterHandlerHook';
import { hasCommentValidValue } from '../utils';
import { MAX_COMMENT_LENGTH } from './CommentComponent';
export var InputField = function (_a) {
    var onSave = _a.onSave;
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var ref = useRef(null);
    var hasValidValue = hasCommentValidValue(value);
    var handleOnSave = function () {
        if (hasValidValue) {
            onSave(value).then(function () {
                var _a, _b;
                setValue('');
                (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector('textarea')) === null || _b === void 0 ? void 0 : _b.blur();
            });
        }
    };
    var handleSaveOnEnter = useOnEnterHandler(handleOnSave);
    return (React.createElement(OutlinedInput, { className: classNames('commentInputField', { 'commentInputField--hasValue': hasValidValue }), margin: "dense", multiline: true, maxRows: 10, fullWidth: true, value: value, endAdornment: React.createElement(IconButton, { size: 'small', className: 'commentInputField__sendButton', disabled: !hasValidValue, onClick: handleOnSave },
            React.createElement(AccurityIcon, { iconName: "mui:SendOutlined" })), onChange: function (e) { return setValue(e.target.value); }, onKeyDown: handleSaveOnEnter, ref: ref, inputProps: { maxLength: MAX_COMMENT_LENGTH } }));
};
//# sourceMappingURL=InputField.js.map